import type { FC } from 'react';
import { DayPicker } from 'react-day-picker';

import { Chevron, DayButton, YearsDropdown } from './components';
import { DatePickerContext } from './DatePicker.context';
import { formatWeekdayName, prepareCustomProps, prepareMatchers } from './helpers';
import { getClassNames } from './styles';
import type { DatePickerProps } from './types';

const DatePicker: FC<DatePickerProps> = (props) => {
  const { additionalInfo, className, disabled, hasError = false, isInline = false, numberOfMonths = 1, tooltip } = props;
  const nextYear: number = new Date().getFullYear() + 1;

  return (
    <DatePickerContext.Provider value={{ tooltip }}>
      <>
        <DayPicker
          captionLayout="dropdown-years"
          classNames={getClassNames({ className, hasError, isInline })}
          components={{ DayButton, Chevron, YearsDropdown }}
          data-testid="date-picker"
          disabled={prepareMatchers(disabled)}
          endMonth={new Date(nextYear, 11)}
          formatters={{ formatWeekdayName }}
          ISOWeek={true}
          numberOfMonths={numberOfMonths}
          {...prepareCustomProps(props)}
        />
        {additionalInfo && additionalInfo}
      </>
    </DatePickerContext.Provider>
  );
};

export default DatePicker;
